import React from "react";
import { CTAButton } from "../CTAButton";
import { AUTHOR_IMAGE } from "../../data/links";
const stagesList = ["Patient history.", "Hair loss pattern assessment.", "Trichoscopy findings.", "Differential diagnosis considerations.", "Documentation and next steps."];
export function Author() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-85" data-mp="1rox9j9xvinsl">
      <div className="mx-auto grid max-w-5xl gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-start" data-id="element-86" data-mp="25h3hi8qvhogy">
        <figure className="lg:sticky lg:top-8" data-id="element-87" data-mp="20iiq8ytlmf4n">
          <img src={AUTHOR_IMAGE} alt="Dr. Daniel Mitchell" className="aspect-[4/5] w-full rounded-3xl object-cover object-top" loading="lazy" data-id="element-88" data-mp="20hqthko9mbcs" />
          <figcaption className="mt-4 text-center" data-id="element-89" data-mp="2agzjy3jx97ue">
            <p className="font-display text-3xl font-extrabold uppercase text-ink" data-id="element-90" data-mp="l105c6xjaq7d">Dr. Daniel Mitchell</p>
            <p className="text-sm font-semibold uppercase tracking-[0.12em] text-brand" data-id="element-91" data-mp="g2yl3iodgkub">
              Hair Loss &amp; Scalp Health Education
            </p>
          </figcaption>
        </figure>

        <div data-id="element-92" data-mp="3kfg5ubaucf6i">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand" data-id="element-93" data-mp="3kgzlbzooam78">A message from the author</p>
          <h2 className="mt-3 font-display text-4xl font-extrabold uppercase leading-[1.02] text-ink sm:text-5xl" data-id="element-94" data-mp="3pe97n6grmhqu">
            Why I believe hair loss education needs a more structured approach.
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink" data-id="element-95" data-mp="2yy7eqnzwj7a">
            <p data-id="element-96" data-mp="7xhx925pmf4x">When studying alopecia, you encounter information from many different sources.</p>
            <p data-id="element-97" data-mp="c17ipir38glq">
              You might review androgenetic alopecia in one textbook, alopecia areata in another
              reference, and trichoscopic findings in a separate collection of clinical images.
            </p>
            <p data-id="element-98" data-mp="2dt2fks8oqgjw">
              Each source may offer valuable information. But when you want to bring those findings
              together, it helps to have a consistent structure.
            </p>
            <p data-id="element-99" data-mp="3m21kg69jw05d">
              That’s the idea behind <strong data-id="element-100" data-mp="3h2ey97bqv9kf">ALOPECIA CLINICAL BLUEPRINT™</strong>. I want this
              educational collection to give you a clear framework for organizing the initial review
              of hair loss presentations.
            </p>
            <p data-id="element-101" data-mp="3q2ttozifa51n">The system is built around five stages:</p>
          </div>
          <ol className="mt-4 space-y-2" data-id="element-102" data-mp="8uq3r5l0ss4e">
            {stagesList.map((s, i) => <li key={s} className="flex items-center gap-3 text-lg font-semibold text-ink" data-id="element-103" data-mp="8sn4duxz9mn0" data-mpi={i}>
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-lg font-extrabold text-white" data-id="element-104" data-mp="3u2dwn8j2hbr">
                  {i + 1}
                </span>
                {s}
              </li>)}
          </ol>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink" data-id="element-105" data-mp="rlzd9eusjgvz">
            <p data-id="element-106" data-mp="mnfqjc8di12k">Together, these stages form the 15-Minute Alopecia Assessment Framework™.</p>
            <p data-id="element-107" data-mp="167wq4vdfb6o8">
              The objective isn’t to rush clinical decisions. It’s to give you an organized process
              for reviewing the information available at the beginning of an assessment.
            </p>
            <p data-id="element-108" data-mp="w978n3pfvo8i">
              The six volumes provide the educational foundations. The five complementary resources
              offer additional case studies, visual references, flowcharts, and worksheets.
            </p>
            <p className="border-l-4 border-gold pl-4 font-semibold" data-id="element-109" data-mp="nflsph1jg0xi">
              My goal is straightforward: to help you spend less effort navigating scattered
              references and more attention on structured professional learning.
            </p>
            <p className="text-ink-muted" data-id="element-110" data-mp="ijna6a2w5d50">
              I also believe it’s important to understand the limits of educational materials. A
              digital reference collection cannot replace clinical training, current evidence-based
              guidelines, individualized patient assessment, or professional judgment.
            </p>
            <p data-id="element-111" data-mp="1jan1aa737dy">
              I hope ALOPECIA CLINICAL BLUEPRINT™ becomes a useful addition to your continuing
              professional education.
            </p>
            <p className="font-display text-2xl font-bold text-ink" data-id="element-112" data-mp="3nvho574cx0dp">— Dr. Daniel Mitchell</p>
          </div>

          <CTAButton className="mt-8" label="Get the complete Alopecia Clinical Blueprint™" note="Just $27 USD · One-time payment" data-id="element-113" data-mp="3ix6eawe2apvh" />
        </div>
      </div>
    </section>;
}